import React from 'react';
import './component-loader.styles.scss';

const InLoader = (props) => {
    const {
        loaderText = null
    } = props;
    return (
        <div className="in-loader">
            <div className="in-loader-icon"></div>
            {loaderText ? <div>{loaderText}</div> : null}
        </div>
    );
};

export default InLoader